export enum ETLJobsTablesEnum {
  SCHEDULED_JOBS = 'scheduled_jobs',
  JOB_HISTORY = 'job_history',
}
